// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import EmailTemplate from "./email-template.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "cron": {
      "column": {
        "default": null,
        "name": "cron",
        "null": true,
        "type": "string"
      },
      "name": "cron",
      "selected_by_default": null,
      "translated": false
    },
    "email_template_id": {
      "column": {
        "default": null,
        "name": "email_template_id",
        "null": false,
        "type": null
      },
      "name": "email_template_id",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "liquid_search": {
      "column": {
        "default": null,
        "name": "liquid_search",
        "null": true,
        "type": "text"
      },
      "name": "liquid_search",
      "selected_by_default": null,
      "translated": false
    },
    "send_at": {
      "column": {
        "default": null,
        "name": "send_at",
        "null": true,
        "type": "datetime"
      },
      "name": "send_at",
      "selected_by_default": null,
      "translated": false
    },
    "send_at_without_time_zone": {
      "column": null,
      "name": "send_at_without_time_zone",
      "selected_by_default": null,
      "translated": false
    },
    "state": {
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": false
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "NewsletterTemplate",
  "collectionKey": "newsletter_templates",
  "collectionName": "newsletter_templates",
  "i18nKey": "newsletter_template",
  "camelizedLower": "newsletterTemplate",
  "name": "NewsletterTemplate",
  "nameDasherized": "newsletter-template",
  "pluralName": "newsletter_templates",
  "ransackable_associations": [
    {
      "className": "NewsletterTemplate::Audit",
      "collectionName": "newsletter_template_audits",
      "foreignKey": "newsletter_template_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplate::Audit",
      "collectionName": "newsletter_template_audits",
      "foreignKey": "newsletter_template_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "NewsletterTemplateAudit",
      "through": null
    },
    {
      "className": "NewsletterTemplate::Translation",
      "collectionName": null,
      "foreignKey": "newsletter_template_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "EmailTemplate",
      "collectionName": "email_templates",
      "foreignKey": "email_template_id",
      "name": "email_template",
      "macro": "belongs_to",
      "resource_name": "EmailTemplate",
      "through": null
    },
    {
      "className": "NewsletterTemplateTableSearch",
      "collectionName": "newsletter_template_table_searches",
      "foreignKey": "newsletter_template_id",
      "name": "newsletter_template_table_searches",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateTableSearch",
      "through": null
    },
    {
      "className": "NewsletterTemplateTimeZoneState",
      "collectionName": "newsletter_template_time_zone_states",
      "foreignKey": "newsletter_template_id",
      "name": "newsletter_template_time_zone_states",
      "macro": "has_many",
      "resource_name": "NewsletterTemplateTimeZoneState",
      "through": null
    },
    {
      "className": "Newsletter",
      "collectionName": "newsletters",
      "foreignKey": "newsletter_template_id",
      "name": "newsletters",
      "macro": "has_many",
      "resource_name": "Newsletter",
      "through": null
    },
    {
      "className": "NewsletterTemplate::Translation",
      "collectionName": null,
      "foreignKey": "newsletter_template_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "cron",
      "column": {
        "default": null,
        "name": "cron",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "email_template_id",
      "column": {
        "default": null,
        "name": "email_template_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "liquid_search",
      "column": {
        "default": null,
        "name": "liquid_search",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "send_at",
      "column": {
        "default": null,
        "name": "send_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "EmailTemplate",
      "collectionName": "email_templates",
      "foreignKey": "email_template_id",
      "name": "email_template",
      "macro": "belongs_to",
      "resource_name": "EmailTemplate",
      "through": null
    }
  ],
  "paramKey": "newsletter_template",
  "primaryKey": "id"
}

/** Frontend model for NewsletterTemplate. */
export default class NewsletterTemplate extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  cron() {
    return this.readAttributeUnderscore("cron")
  }

  /** @returns {boolean} */
  hasCron() {
    const value = this.cron()

    return this._isPresent(value)
  }

  /** @returns {any} */
  emailTemplateId() {
    return this.readAttributeUnderscore("email_template_id")
  }

  /** @returns {boolean} */
  hasEmailTemplateId() {
    const value = this.emailTemplateId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  liquidSearch() {
    return this.readAttributeUnderscore("liquid_search")
  }

  /** @returns {boolean} */
  hasLiquidSearch() {
    const value = this.liquidSearch()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  sendAt() {
    return this.readAttributeUnderscore("send_at")
  }

  /** @returns {boolean} */
  hasSendAt() {
    const value = this.sendAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  sendAtWithoutTimeZone() {
    return this.readAttributeUnderscore("send_at_without_time_zone")
  }

  /** @returns {boolean} */
  hasSendAtWithoutTimeZone() {
    const value = this.sendAtWithoutTimeZone()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  usersToReceive(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "users_to_receive",
        primaryKey: this.primaryKey(),
        collectionName: "newsletter_templates",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./email-template.js").default | null} */
  emailTemplate() {
    return this._readBelongsToReflection({modelClass: EmailTemplate, reflectionName: "email_template"})
  }

  /** @returns {Promise<import("./email-template.js").default | null>} */
  loadEmailTemplate() {
    if (!("emailTemplateId" in this)) throw new Error("Foreign key method wasn't defined: emailTemplateId")

    const id = this.emailTemplateId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "email_template",
        model: this,
        modelClass: EmailTemplate
      },
      {ransack}
    )
  }
}
